import { ThemeInterface } from "injectors/theme";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme: ThemeInterface) => ({
  container: {},
  noDocumentsIcon: {
    fontSize: 60,
    margin: "20px 0",
    color: theme.colors.lightGray.toString(),
  },
  noDocumentsContainer: {
    textAlign: "center",
  },
  noDocumentsText: {
    color: theme.colors.offBlack.toString(),
    fontWeight: 400,
  },
  downloadAllButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  h2: {
    fontSize: 17,
    fontStyle: "normal",
    fontFamily: "Open sans, sans-serif",
    fontWeight: 400,
    marginBottom: "16px",
  },
}));

export { useStyles };
